module.exports = __webpack_public_path__ + "static/media/lightbulb-exclamation.e6b456a6.svg";